module.exports = __webpack_public_path__ + "static/media/orderComplete.e4abd733.png";